module.exports = __webpack_public_path__ + "img/teddi-hunter.bd76ffd4.svg";